import React from 'react';

export default function WistiaVideoPlayer(props) {
    var join = props.url.includes('?') ? '&' : '?';
    const url = props.url + join + 'email='+localStorage.getItem("email_address");    
    return (
        <div className="wistia-player" style={{ height: "100%", width: "100%" }}>
            <div className="wistia_responsive_padding" style={{ padding: "56.0% 0 0 0", position: "relative" }} >
                <div className="wistia_responsive_wrapper" style={{ height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }} >
                    <iframe src={url} title="Wistia video player" allowtransparency="true" frameBorder="0" scrolling="no" className="wistia_embed" name="wistia_embed" allowFullScreen autoPlay={true} width="100%" height="100%" />
                </div>
            </div>
            <script src="https://fast.wistia.net/assets/external/E-v1.js" async />
        </div>
    )
}


// WEBPACK FOOTER //
// src/client/components/common/media/WistiaVideoPlayer.js